import assignmentService from 'ApiService/Student/assignmentService';
import TestComponent from '../Index';

const Index = () => {
  const title = 'No Daily Assignment Assigned Yet.';
  const fetchAssignment = async () => {
    return await assignmentService.getDailyAssignment();
  };
  return <TestComponent fetchTests={fetchAssignment} NoData={title} />;
};

export default Index;
